var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"sea-page"}},[(_vm.header)?_c('sea-header',{attrs:{"separator":_vm.headerSeparator}},[_vm._v(_vm._s(_vm.header))]):_vm._e(),_c('v-container',{attrs:{"fluid":"","id":"sea-page-content"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }